<template>
  <div>
    <SectionTitle>Gateway</SectionTitle>
    <div class="flex items-center">
      <DeviceImg
        v-if="selectedProperty.property?.gateway?.id"
        class="w-28"
        :device="selectedProperty.property?.gateway"
      />
      <div class="py-4 flex-1">
        <div v-if="!selectedProperty.property?.gateway?.id">
          <IonList inset>
            <SerialNumberInput
              v-model:serial="programGatewayInput.value"
              :state="programGatewayInput.state"
              :errors="programGatewayInput.errors"
              gray
              title="Program Gateway"
              id="program-gateway-sn"
            ></SerialNumberInput>
            <SaveFormButtons
              @cancel="programGatewayInput.reset()"
              :saving="saving"
              @save="programGateway()"
              :show="programGatewayInput.dirty"
              :disabled="!programGatewayInput.valid || !programGatewayInput.value"
            ></SaveFormButtons>
          </IonList>
        </div>
        <DeviceOnlineStatus
          @on-sync-complete="selectedProperty.refresh()"
          v-else
          :device="selectedProperty.property?.gateway"
          justify="left"
        />
      </div>
    </div>
    <div v-if="selectedProperty.property?.gateway?.id" class="flex justify-center relative -top-4">
      <BaseClearButton size="small" @click="goToGatewayPage">
        <i class="icon-eye mr-2 text-base"></i>
        View Details
      </BaseClearButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseClearButton from '@/components/forms/BaseClearButton.vue';
import SectionTitle from '@/components/forms/SectionTitle.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { createAnimation, IonList, useIonRouter } from '@ionic/vue';
import DeviceOnlineStatus from '../../components/DeviceOnlineStatus.vue';
import DeviceImg from '../../components/DeviceImg.vue';
import SerialNumberInput from '@/components/forms/serial-input/SerialNumberInput.vue';
import { useFormControl } from '@/composables/use-form-control';
import {
  DeviceFamilyValidator,
  UnprogrammedDeviceValidator,
} from '@/composables/validators/serial-form-control-validators';
import { DeviceFamily } from '@ncss/models';
import SaveFormButtons from '@/components/forms/SaveFormButtons.vue';
import { useToast } from '@/composables/use-toast';
import { ref } from 'vue';

const router = useIonRouter();
const selectedProperty = useSelectedProperty();
const programGatewayInput = useFormControl(() => undefined, {
  validators: [DeviceFamilyValidator([DeviceFamily.GATEWAY])],
  asyncValidators: [UnprogrammedDeviceValidator()],
});
const { successToast, errorToast } = useToast();
const saving = ref(false);

async function programGateway() {
  saving.value = true;
  if (programGatewayInput.valid && programGatewayInput.value) {
    const { success, error } = await selectedProperty.addGateway(programGatewayInput.value);
    if (success) {
      successToast('Gateway programmed!');
      programGatewayInput.reset();
    } else if (error) {
      errorToast(error);
    }
  }
  saving.value = false;
}

function goToGatewayPage() {
  return router.push(`/gateway/${selectedProperty.propertyId}`);
}
</script>
